import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  IconButton,
  Chip,
  Grid
} from '@mui/material';

import {
  Star,
  Verified,
  CheckCircle,
  MonetizationOn,
  CurrencyBitcoin,
  Close
} from '@mui/icons-material';

import SendIcon from '@mui/icons-material/Send';
import MembershipPricing from './membershipPricing';
import FavorDialog from './favor';
import { useMediaQuery } from "@mui/material";
import theme from '../../styles/theme';
import { DOMAIN } from '../../config';

const UserProfile = ({
  sign = 0,
  username = '',
  isVIP = false,
  isVerified = true,
  downloadsRemaining = 5,
  silverCoins = 120,
  goldCoins = 30,
  onSignIn = () => { },
  onOpenVIP = () => { },
  onVerify = () => { },
  onClose = () => { },
  onShareApp = () => { },
  onLogout = () => { },
  vipExpire
}) => {
  const [showMembership, setShowMembership] = useState(false);
  const [openFavor, setOpenFavor] = useState(false);
  const [chipTitle, setChipTitle] = useState(null);
  const [remark, setRemark] = useState(false);
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const isStillVIP = isVIP && new Date(vipExpire).getTime() > Date.now();

  // ✨ 中间提示框
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });

  // ✨ 强制刷新组件
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenFavor = (text) => {
    setChipTitle(text);
    setRemark(true);
    setOpenFavor(true);
  };

  const handleSilverVip = () => {
    fetch(`${DOMAIN}ywyminiappbot/silverBuyVip`, {
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        const msg = data?.msg;
        if (msg === 'silver is not') {
          setSnackbar({ open: true, message: '银币不足' });
        } else if (msg === 'success') {
          setSnackbar({ open: true, message: '兑换了31天会员' });
          setTimeout(() => {
            setSnackbar({ open: false, message: '' });
            onClose(); // 关闭组件
          }, 2000);
        }
      })
      .catch(() => {
        setSnackbar({ open: true, message: '兑换失败，请稍后再试' });
      });
  };

  useEffect(() => {
    if (snackbar.open) {
      const timer = setTimeout(() => {
        setSnackbar({ open: false, message: '' });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [snackbar]);

  return (
    <>
      {/* 收藏弹窗 */}
      <FavorDialog
        openSearch={openFavor}
        setOpenSearch={setOpenFavor}
        matches={matches}
        chipTitle={chipTitle}
      />

      {/* ✨ 自定义提示框：黑底白字居中 */}
      {snackbar.open && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            px: 4,
            py: 2,
            borderRadius: 2,
            fontSize: '1rem',
            zIndex: 2000,
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          }}
        >
          {snackbar.message}
        </Box>
      )}

      {/* 用户信息卡片 */}
      <Box key={refreshKey} sx={{ p: 0, display: 'flex', justifyContent: 'center' }}>
        <Card sx={{
          p: 3,
          maxWidth: 600,
          width: '100%',
          position: 'relative',
          borderRadius: 4,
          boxShadow: 4,
          background: 'linear-gradient(to bottom right, #f7f0ff, #ffffff)'
        }}>
          <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
            <Close />
          </IconButton>

          <CardContent>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#4a148c' }}>
              👤 用户信息
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body1" fontWeight="medium">
                  用户名: <strong>{username}</strong>
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" fontWeight="medium">
                  身份:
                  {isStillVIP ? (
                    <Chip
                      label={`VIP会员（到期: ${vipExpire}）`}
                      sx={{
                        ml: 1,
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        fontWeight: 'bold'
                      }}
                    />
                  ) : (
                    <Box component="span" sx={{ ml: 1 }}>
                      普通用户
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<Star sx={{ color: 'white' }} />}
                        sx={{
                          ml: 1,
                          minWidth: 80,
                          fontSize: '0.75rem',
                          background: 'linear-gradient(45deg, #FFD700 0%, #aa00ff 90%)',
                          color: 'white',
                          borderRadius: 3,
                          textTransform: 'none',
                          boxShadow: '0 2px 4px rgba(170, 0, 255, 0.3)',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #ffb300 0%, #9900cc 90%)',
                          }
                        }}
                        onClick={() => setShowMembership(true)}
                      >
                        开通会员
                      </Button>
                      {showMembership && (
                        <MembershipPricing
                          open={showMembership}
                          onClose={() => setShowMembership(false)}
                        />
                      )}
                    </Box>
                  )}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" fontWeight="medium">
                  绑定电报:
                  {isVerified ? (
                    <Chip
                      icon={<Verified color="primary" />}
                      label="已绑定"
                      sx={{ ml: 1 }}
                    />
                  ) : (
                    <Box component="span" sx={{ ml: 1 }}>
                      未绑定
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<SendIcon />}
                        onClick={onVerify}
                        sx={{
                          ml: 1,
                          fontSize: '0.78rem',
                          fontWeight: 500,
                          textTransform: 'none',
                          color: '#aa00ff',
                          border: '1.5px solid #aa00ff',
                          borderRadius: '20px',
                          backgroundColor: 'white',
                          px: 2,
                          '&:hover': {
                            background: 'linear-gradient(to right, #f3e5f5, #ede7f6)',
                            borderColor: '#9900cc'
                          }
                        }}
                      >
                        前往绑定
                      </Button>
                    </Box>
                  )}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">
                  <MonetizationOn color="action" sx={{ verticalAlign: 'middle', mr: 1 }} />
                  银币: <strong>{silverCoins}</strong>
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">
                  <CurrencyBitcoin color="warning" sx={{ verticalAlign: 'middle', mr: 1 }} />
                  金币: <strong>{goldCoins}</strong>
                </Typography>
              </Grid>
            </Grid>
          </CardContent>

          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
            {/* <Button
              variant={sign ? 'outlined' : 'contained'}
              startIcon={<CheckCircle />}
              onClick={sign ? null : onSignIn}
              disabled={sign}
              sx={{
                background: sign ? 'transparent' : 'linear-gradient(45deg, #66bb6a, #43a047)',
                color: sign ? '#9e9e9e' : '#fff',
                borderRadius: '12px',
                fontSize: '0.85rem',
                py: 1.2,
                textTransform: 'none',
                border: sign ? '1px solid #ccc' : 'none',
                '&:hover': {
                  background: sign ? 'transparent' : 'linear-gradient(45deg, #81c784, #388e3c)',
                },
              }}
            >
              {sign ? '已签到，银币+1' : '签到'}
            </Button> */}

            <Button
              variant="outlined"
              startIcon={<SendIcon />}
              onClick={() => handleOpenFavor('我的收藏')}
              sx={{
                color: '#aa00ff',
                borderColor: '#aa00ff',
                borderRadius: '12px',
                fontSize: '0.85rem',
                py: 1.2,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#f3e5f5',
                  borderColor: '#9900cc',
                }
              }}
            >
              我的收藏
            </Button>

            <Button
              variant="outlined"
              startIcon={<SendIcon />}
              onClick={handleSilverVip}
              sx={{
                color: '#aa00ff',
                borderColor: '#aa00ff',
                borderRadius: '12px',
                fontSize: '0.85rem',
                py: 1.2,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#f3e5f5',
                  borderColor: '#9900cc',
                }
              }}
            >
              银币换会员（70个银币）
            </Button>

            <Button
              variant="text"
              startIcon={<Close />}
              onClick={onLogout}
              sx={{
                color: '#d32f2f',
                borderRadius: '12px',
                fontSize: '0.85rem',
                py: 1.2,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#ffebee',
                }
              }}
            >
              退出登录
            </Button>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default UserProfile;
